import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useLingui } from "@lingui/react/macro";
import { revertCancellationOccurrenceGroup } from "@/api/Activities";
import { deducedError, useErrorMessageAlert } from "@/Utils/ErrorUtils";

export const useResumeGroup = (groupId: string) => {
  const queryClient = useQueryClient();
  const { displayErrorMessageAlert } = useErrorMessageAlert();
  const { t } = useLingui();

  const { mutate: resumeGroup, isPending: isResumingGroup } = useMutation({
    mutationFn: () => revertCancellationOccurrenceGroup(groupId),
    onError: (error) => {
      displayErrorMessageAlert(
        `${t`Det gick inte att återuppta besöket.`} ${deducedError(error)}`,
      );
    },
    onSuccess: () => queryClient.invalidateQueries(),
  });

  return { resumeGroup, isResumingGroup };
};
